<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button
    *ngPermissions="permissionService.Permission.weekly_schedule_create"
    type="button"
    sb-button-primary
    [color]="'green'"
    [icon]="'plus'"
    [loading]="loading()"
    [iconButton]="true"
    [sbRouterLink]="util.RoutingID.weeklyScheduleCreate"
    sbTooltip="{{ 'lang.weeklySchedule.create' | translate }}"
  >
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>

<!------------------------------

     Table Wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'nav.weeklySchedule' | translate}}"
  [itemsData]="weeklySchedules"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'weeklySchedules'">

  <!------------------------------

        Filter Panel

  ------------------------------->
  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>

  <!------------------------------

       Table Header

  ------------------------------->
  <ng-template #thead>
    <tr class="noselect">
      <th>ID</th>
      <th>{{ 'lang.globals.name' | translate }}</th>
      <th>{{ 'lang.globals.description' | translate }}</th>
      <!-- <th>{{'lang.globals.assignments' | translate}}</th> -->
      <th class="sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>

  <!------------------------------

 Table Body

------------------------------->
  <ng-template #tbody let-weeklySchedule>
    @let isSelected = selectedSchedule?.id === weeklySchedule?.id;
    <tr [ngClass]="{'selected': isSelected}">
      <td>{{ weeklySchedule.id }}</td>
      <td>{{ weeklySchedule.name }}</td>
      <td>{{ weeklySchedule.description }}</td>
      <!-- <td>{{ 'lang.weeklySchedule.noLocationAssignment' | translate }}</td>-->
      <td class="tr bw sticky-col last-col">
        @if (!isInModalContext) {
          <sb-split-button
            [splitButtonItems]="weeklySchedule.sbButtons ?? []"
            (selectedAction)="resolveSplitButtonAction(weeklySchedule, $event)"
          ></sb-split-button>
        } @else {
          <button
            sb-button-secondary
            type="button"
            [ngbTooltip]="'lang.globals.select' | translate"
            (click)="selectSchedule(weeklySchedule)"
            [ngClass]="{'btn-hover-primary--active': weeklySchedule?.id === selectedSchedule?.id}"
            [iconButton]="true">
            @if (isSelected) {
              <sb-icon icon="boxChecked"></sb-icon>
            } @else {
              <sb-icon icon="box"></sb-icon>
            }
          </button>
        }
      </td>
    </tr>
  </ng-template>

  <!------------------------------

Card Element

TODO: create card element

------------------------------->
</sb-table-wrapper-new>
